// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';


export default class TextEditor extends WebComponent {
	didMount() {
		tinymce.init({
			target: this.element,
			language: 'sk',
			body_class: 'wysiwyg-content',
			language_url: '/files/tinymce/langs/sk.js',
			inline_styles: false,
			entity_encoding: 'raw',
			branding: false,
			menubar: false,
			content_css: '/files/tinymce.css',
			plugins: 'advlist link lists table',
			toolbar: 'alignleft aligncenter alignright | bold italic underline | bullist numlist | table link | blockquote',
			setup : function(editor) {
				editor.on("change keyup", function(e){
					editor.save();
				});
			}

		});
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/TextEditor.js